import { ViewModel, View, ObservableArray } from "binder"
import { PaymentGatewaySelectorView } from "./paymentGatewaySelector-view"
import { IGateway, PaymentInfo } from "./gateways/IGateway";
import { AccountGatewayViewModel } from "./gateways/accountGateway/accountGateway-viewModel";
import { CashGatewayViewModel } from "./gateways/cashGateway/cashGateway-viewModel";
import { ChequeGatewayViewModel } from "./gateways/chequeGateway/chequeGateway-viewModel";
import { DebitGatewayViewModel } from "./gateways/debitGateway/debitGateway-viewModel";
import { IbanGatewayViewModel } from "./gateways/ibanGateway/ibanGateway-viewModel";


export class PaymentGatewaySelectorViewModel extends ViewModel {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.gateways = ObservableArray.create<IGateway>();
        this.gateways.push(...[
            new CashGatewayViewModel(this),
            new DebitGatewayViewModel(this),
            new IbanGatewayViewModel(this),
            new AccountGatewayViewModel(this),
            new ChequeGatewayViewModel(this)
        ]);
        this.paymentInfo = new PaymentInfo(this);
    }
    GetDefaultView(): View<ViewModel> {
        return new PaymentGatewaySelectorView();
    }
    public getTypeId(): string {
        return "VM-25129055-A75A-49A4-A4F0-BB78D11A9BA3"
    }

    public set gateways(v: ObservableArray<IGateway>) { this._gateways = v; } public get gateways(): ObservableArray<IGateway> { return this._gateways; } private _gateways: ObservableArray<IGateway>;
    public set paymentInfo(v: PaymentInfo) { this._paymentInfo = v; } public get paymentInfo(): PaymentInfo { return this._paymentInfo; } private _paymentInfo: PaymentInfo;
    public set selectedGateway(v: IGateway) {
        v?.initialLoad(this.paymentInfo);
        this._selectedGateway = v;
    } public get selectedGateway(): IGateway { return this._selectedGateway; } private _selectedGateway: IGateway;
}
